import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { mergeMap, Observable, of } from 'rxjs';
import { CouponsResponse } from '../model/coupons-response';
import { AuthenticateService } from './authenticate.service';
import { envs } from '../data/env.data';

@Injectable({
  providedIn: 'root',
})
export class SocialOffersService {
  private readonly http = inject(HttpClient);
  private readonly authService = inject(AuthenticateService);

  getSocialOffers(offer: string, banner: string): Observable<CouponsResponse> {
    const token = this.authService.getApiAuthToken();
    const url = `${envs.apiBaseUrl}/${banner}/coupons/socialoffers/${offer}`;
    const header = { Authorization: token };
    return this.http.get<CouponsResponse>(url, { headers: header }).pipe(
      mergeMap((data: CouponsResponse) => {
        return of(data);
      })
    );
  }
}
